import type { MagicRecipe } from '../shared/vfx-recipe-contract';
import { normalizeRollVfx } from '../janus-engine/presentation/roll-vfx-cue';
import {spellPresentationTiming} from '../shared/spell-cast-timing';
import {postFt3dPresentation} from './scene-frame';
type Binding = { name: string; recipe: MagicRecipe; review: boolean };
type Catalog = Record<string, Binding>;
/** Consume only resolved, viewer-authorized rows. Never arm targeting or replay log history. */
export function magicCueFromRoll(roll: Record<string, unknown>, bindings: Catalog, rollTypes: Record<string,{item_id?:string}>, isGm: boolean): Record<string,unknown> | null {
  if (Number(roll.roll_private || 0)>0 && !isGm
    && !(Number(roll.roll_private)===2 && Number(roll.campaign_permission)===1 && roll.roll_vfx)) return null;
  const itemId=String(roll.roll_item_id||'').toUpperCase();
  // Ordinary rolls arrive normalized before audio. Review-only bindings use that same native decision.
  const binding=bindings[itemId];
  const cue=roll.roll_vfx ?? (binding?.review && !Object.prototype.hasOwnProperty.call(roll,'roll_vfx_recipe')
    ? normalizeRollVfx<Record<string,unknown>>({...roll,roll_vfx_recipe:binding.recipe},rollTypes).roll_vfx : null);
  if(!cue || typeof cue!=='object' || Array.isArray(cue))return null;
  const result=cue as Record<string,unknown>;
  if(result.schema!=='ft.ft3d.magic-cue.v1' || result.itemId!==itemId
    || result.sourceEntityId!==String(roll.roll_by||'').toUpperCase()
    || result.targetEntityId!==String(roll.roll_to||'').toUpperCase()
    || String(result.encounterId||'').toUpperCase()!==String(roll.encounter_id||'').toUpperCase()
    || !String(result.id||'').startsWith(String((roll.roll_presentation as {actionId?:string}|undefined)?.actionId||roll.roll_vfx_action_id||roll.roll_id||'')+':'))return null;
  return {...result,...(typeof roll.roll_motion==='string'?{motion:roll.roll_motion}:{})};
}

export function mountFt3dMagicVfxFeedback(): void {
  const boot=document.getElementById('ft-boot-data');
  let bindings:Catalog={};
  try {bindings=JSON.parse(boot?.textContent||'{}').session?.magicVfx||{};}catch{return;}
  const seen=new Set<string>();
  const handle=(event:Event)=>{
    const roll=(event as CustomEvent).detail?.roll;
    if(!roll || typeof roll!=='object' || Array.isArray(roll))return;
    const host=window as unknown as {ROLLTYPE_CATALOG?:Record<string,{item_id?:string}>;FateTide?:{user?:{isGM?:boolean}};ftGetActiveEncounterId?:()=>string};
    const currentEncounter=host.ftGetActiveEncounterId?.();
    if(currentEncounter && roll.encounter_id && String(currentEncounter).toUpperCase()!==String(roll.encounter_id).toUpperCase())return;
    const cue=magicCueFromRoll(roll,bindings,host.ROLLTYPE_CATALOG||{},!!host.FateTide?.user?.isGM);
    const duplicate=!!cue&&seen.has(String(cue.id));
    document.dispatchEvent(new CustomEvent('ft:ft3d-magic-cue-decision',{detail:{
      rollId:String(roll.roll_id||''),cueId:cue?.id??null,decision:!cue?'no-cue':duplicate?'duplicate':'accepted',
    }}));
    if(!cue || duplicate)return;
    seen.add(String(cue.id));
    const timing=spellPresentationTiming(cue);
    postFt3dPresentation({type:'ft3d-campaign-magic-cue-v1',payload:timing?{...cue,presentationTiming:timing}:cue});
  };
  document.addEventListener('ft-roll-authorized',handle);
  document.addEventListener('ft-magic-area-authorized',handle);
  document.addEventListener('ft-magic-target-authorized',handle);
}
